"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginController = void 0;
class LoginController {
    constructor($scope, $location, loginService) {
        this.$scope = $scope;
        this.$location = $location;
        this.loginService = loginService;
        this.saveBusy = false;
        $scope.login = function (isFormValid) {
            if (isFormValid) {
                loginService.login($scope.username, $scope.password)
                    .then((status) => {
                    $location.path("/homepage").search('error', null);
                }, (response) => {
                    var errorText = "Inloggen mislukt t.g.v. een technische fout";
                    if (response.status === 401) {
                        errorText = "Inloggen mislukt. De gebruikersnaam of het wachtwoord is ongeldig";
                    }
                    if (response.status === 403) {
                        errorText = response.data;
                    }
                    $location.path("/login").search({ error: errorText });
                });
            }
        };
        $scope.errortext = $location.search()["error"];
    }
}
exports.LoginController = LoginController;
LoginController.$inject = ['$scope', '$location', 'loginService'];
